import { Box, Button, styled } from '@mui/material';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import { PlusFlowNode } from './nodes.types';

export const PlusNode = ({ id, data }: NodeProps<PlusFlowNode>) => {
  const { onClick } = data;

  return (
    <NodeWrapper className="nopan" data-testid="plus-node">
      <Handle type="target" position={Position.Left} />
      <NodeLabel
        variant="contained"
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(id);
        }}
      >
        +
      </NodeLabel>
    </NodeWrapper>
  );
};

const NodeWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'transparent',
  width: 40,
  height: 40,
}));

const NodeLabel = styled(Button)(({ theme }) => ({
  minWidth: 32,
  width: 32,
  height: 32,
  borderRadius: '999px',
  padding: 0,
  lineHeight: 1,
  backgroundColor: theme.palette.lwSecondaryAccentLight[100],
}));
